import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { TableRow } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export { StyledTableCell, StyledTableRow }